'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initialState = undefined;

var _immutable = require('immutable');

var _redux = require('redux');

var _actionTypes = require('../constants/actionTypes');

var types = _interopRequireWildcard(_actionTypes);

var _companyProfile = require('./companyProfile');

var _companyProfile2 = _interopRequireDefault(_companyProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var companyInfoReceived = function companyInfoReceived() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	var _ref = arguments[1];
	var type = _ref.type;

	switch (type) {
		case types.RECEIVE_COMPANY_INFO:
			return true;
		default:
			return state;
	}
};

var initialState = (0, _immutable.Map)({
	companyProfile: _companyProfile.initialCompanyProfileState,
	companyInfoReceived: companyInfoReceived
});

exports.initialState = initialState;

var _default = (0, _redux.combineReducers)({
	companyInfoReceived: companyInfoReceived,
	companyProfile: _companyProfile2.default
});

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(companyInfoReceived, 'companyInfoReceived', 'src/reducers/index.js');

	__REACT_HOT_LOADER__.register(initialState, 'initialState', 'src/reducers/index.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/reducers/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/reducers/index.js
// module id = CIye
// module chunks = 62 63